import conf from 'conf';
import axios from 'axios';
var BookingCancelationHttpService = /** @class */ (function () {
    function BookingCancelationHttpService() {
    }
    BookingCancelationHttpService.cancelBooking = function (form, files) {
        var formData = new FormData();
        files.forEach(function (wrapper) {
            var file = wrapper.file;
            formData.append('files', file, file.name);
        });
        var json = JSON.stringify(form);
        var blob = new Blob([json], {
            type: 'application/json'
        });
        formData.append('request', blob);
        return axios
            .post(conf.btApiUrl + BookingCancelationHttpService.BASE_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(function (response) { return Promise.resolve(response); })
            .catch(function (error) { return Promise.reject(error.response); });
    };
    BookingCancelationHttpService.BASE_URL = '/contact/service/multipart/v5/cancelBooking';
    return BookingCancelationHttpService;
}());
export default BookingCancelationHttpService;
